<template>
  <div v-title :data-title="textTitle">
    <div id="home" v-if="!iframeUrl" style="padding-top: 2.90rem;" :style="{backgroundImage:`url(${bgImg})`}">
      <van-form>.
        <div class="content">
          <!--学校-->
          <template>
            <van-field readonly clickable name="picker" :value="campusName" required placeholder="点击选择学校" @click="showCampus = true">
              <template slot="button">
                <van-icon name="arrow-down"/>
              </template>
            </van-field>
            <van-popup v-model="showCampus" position="bottom">
              <van-picker show-toolbar :columns="campusList" value-key="locate" :option="{ value: 'locatecode', label: 'locate' }" @confirm="onConfirmCampus" @cancel="showCampus = false"/>
            </van-popup>
            <div style="color: red; margin-bottom: 8px; margin-left: 15px" v-if="schcodeShow">
              校区不能为空
            </div>
          </template>
          <!--运营商-->
          <template>
            <div class="flex align-center">
              <div style="margin-right: 10px">
                <van-field readonly clickable name="picker" required :value="operatorsName" placeholder="运营商" @click="showOperator = true">
                  <template slot="button">
                    <van-icon name="arrow-down"/>
                  </template>
                </van-field>
                <van-popup v-model="showOperator" position="bottom">
                  <van-picker show-toolbar :columns="operatorsList" value-key="label" :option="{ value: 'value', label: 'label' }" @confirm="onConfirmOperators" @cancel="showOperator = false"/>
                </van-popup>
              </div>
              <div style="min-width: 4.1rem">
                <van-field name="radio" style="padding: 0px; background: #fff">
                  <template #label>
                    <div style="font-size:12px;">是否办理过携号转网？</div>
                  </template>
                  <template #input>
                    <van-radio-group v-model="form.iswithno" direction="horizontal">
                      <van-radio name="1">是
                        <template #icon="props">
                          <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon"/></template>
                      </van-radio>
                      <van-radio name="0">否
                        <template #icon="props"><img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon"/></template>
                      </van-radio>
                    </van-radio-group>
                  </template>
                </van-field>
              </div>
            </div>
            <div style="color: red; margin-bottom: 8px; margin-left: 15px" v-if="seloperShow">
              运营商不能为空
            </div>
          </template>
          <template>
            <van-field clickable v-model="form.telephone" required placeholder="请输入你的手机号码" @focus="defalutFocus" @blur="defaultBlur(form.telephone)"></van-field>
            <div style="color: red; margin-left: 15px; margin-bottom: 8px" v-if="telephoneShow">
              手机号不能为空
            </div>
            <div style="color: red; margin-left: 15px; margin-bottom: 8px" v-if="telephoneGs">
              请输入正确的手机号码
            </div>
          </template>
          <!--动态表单-->
          <template>
            <template v-for="(item, index) in formList">
              <div :key="index" v-if="item.show">
                <!--验证码-->
                <template v-if="item.id == 'verifycode'">
                  <div class="flex">
                    <van-field clickable style="margin-right: 10px" @blur="blurField(item)" :required="item.required" v-model="item.value" placeholder="请输入验证码"></van-field>
                    <div>
                          <van-button v-if="!getCodeShow" @click="getCode" style="min-width: 2.2rem; border-radius: 5px" color="linear-gradient(to right, #0d4bed, #0293fc)">获取验证码
                          </van-button>
<!--                      <van-button v-if="!getCodeShow" @click="getTCode" style="min-width: 2.2rem; border-radius: 5px" color="linear-gradient(to right, #0d4bed, #0293fc)">获取验证码-->
<!--                      </van-button>-->
                      <div class="flex align-center" v-show="getCodeShow" style="min-width: 2.2rem;border: 1px #eee solid; padding: 10px 16px; line-height: 24px; border-radius: 5px;">
                        <van-count-down ref="countDown" millisecond :time="60000" :auto-start="false" format="ss" @finish="finish"/>
                        <span class="theme_color">重新获取</span>
                      </div>
                    </div>
                  </div>
                  <div style="color: red; margin-bottom: 8px; margin-left: 15px" v-if="item.checkTxt">
                    {{ item.checkTxt }}
                  </div>
                </template>
                <template v-else-if="item.id == 'dormitory'">
                  <van-field readonly clickable name="picker" :required="item.required" :value="schoolroomName" placeholder="点击选择宿舍楼" @click="showSchoolroom = true">
                    <template slot="button">
                      <van-icon name="arrow-down"/>
                    </template>
                  </van-field>
                  <!-- @confirm="onConfirmCampus" -->
                  <van-popup v-model="showSchoolroom" position="bottom">
                    <van-picker show-toolbar :columns="schoolroomList" value-key="room" :option="{ value: 'id', label: 'room' }" @confirm="onConfirmSchoolroom" @cancel="showSchoolroom = false"/>
                  </van-popup>
                  <div style="color: red; margin-bottom: 8px; margin-left: 15px" v-if="item.checkTxt">
                    {{ item.checkTxt }}
                  </div>
                  <div v-if="item.fieldDescription" style="margin-bottom: 8px" class="flex align-center">
                    <van-icon color="#ff962b" size="15" style="margin: 0 5px" name="question-o"/>
                    <span>{{ item.fieldDescription }}</span>
                  </div>
                </template>
                <!--入学年限-->
                <template v-else-if="item.id == 'enrolledyear'">
                  <van-field readonly clickable required name="picker"  :value="item.value" @click="showEnrolledyear = true;" :placeholder="'请选择' + item.fieldName">
                    <template slot="button">
                      <van-icon name="arrow-down"/>
                    </template>
                  </van-field>
                  <van-popup v-model="showEnrolledyear" position="bottom">
                    <van-picker show-toolbar :columns="getEnrolledyear()" :default-index="getEnrolledyear().length - 1" @confirm="onConfirmEnrolledyear" @cancel="showEnrolledyear = false"/>
                  </van-popup>
                  <div style="color: red; margin-bottom: 8px; margin-left: 15px" v-if="item.checkTxt">
                    {{ item.checkTxt }}
                  </div>
                  <div v-if="item.fieldDescription" style="margin-bottom: 8px" class="flex align-center">
                    <van-icon color="#ff962b" size="15" style="margin: 0 5px" name="question-o"/>
                    <span>{{ item.fieldDescription }}</span>
                  </div>
                </template>
                <!--办理方式-->
                <template v-else-if="item.id == 'handleType'">
                  <van-field name="radio" label="办理方式" :required="item.required" style="background: #fff" @blur="blurField(item)">
                    <template #input>
                      <van-radio-group v-model="item.value" direction="horizontal">
                        <van-radio name="4"> 上门办理
                          <template #icon="props">
                            <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon"/></template>
                        </van-radio>
                        <van-radio name="5"> 服务点办理
                          <template #icon="props"><img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon"/></template>
                        </van-radio>
                      </van-radio-group>
                    </template>
                  </van-field>
                  <div style="color: red; margin-bottom: 8px; margin-left: 15px" v-if="item.checkTxt">
                    请选择办理方式
                  </div>
                </template>
                <!--是否开通5G双域-->
                <template v-else-if="item.id == 'enable5g'">
                  <van-field name="radio" label="是否开通5G随行专网？" :required="item.required" style="background: #fff">
                    <template #input>
                      <van-radio-group v-model="item.value" direction="horizontal">
                        <van-radio name="1"> 是
                          <template #icon="props">
                            <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon"/></template>
                        </van-radio>
                        <van-radio name="0"> 否
                          <template #icon="props"><img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon"/></template>
                        </van-radio>
                      </van-radio-group>
                    </template>
                  </van-field>
                  <div @click="jump5g" style="color: #376fd9;padding-left: 15px;margin-top:-12px;">查看5G随行专网服务说明</div>
                </template>
                <template v-else>
                  <van-field clickable :required="item.required" v-model="item.value" @blur="blurField(item)" :placeholder="'请输入' + item.fieldName"></van-field>
                  <div style="color: red; margin-bottom: 8px; margin-left: 15px" v-if="item.checkTxt">
                    {{ item.checkTxt }}
                  </div>
                  <div v-if="item.fieldDescription" style="margin-bottom: 8px" class="flex align-center">
                    <van-icon color="#ff962b" size="15" style="margin: 0 5px" name="question-o"/>
                    <span>{{ item.fieldDescription }}</span>
                  </div>
                </template>
              </div>
            </template>
          </template>
        </div>
        <div class="content" style="margin-top: 12px">
          <!--选择产品-->
          <template>
            <van-field readonly clickable required name="picker" :value="productName" :placeholder="`请选择${vueType == 'kd' ? '宽带' : vueType == 'yx' ? '营销' : vueType == 'kk' ? '开卡' : ''}产品`" @click="clickProduct" style="margin-bottom: 0">
              <template slot="button">
                <van-icon name="arrow-down"/>
              </template>
            </van-field>
            <van-popup v-model="showProduct" position="bottom">
              <van-picker show-toolbar :columns="productList" value-key="name" :option="{ value: 'code', label: 'name' }" @confirm="onConfirmProduct" @cancel="showProduct = false"/>
            </van-popup>
            <div style="color: red; margin-top: 8px; margin-left: 15px" v-if="suprcodeShow">
              产品不能为空
            </div>
          </template>
          <div class="rich-text-container flex align-center" style="margin: 0.2rem 0;">
            <input type="checkbox" v-model="readAgrement"/>
            <span style="font-size: 0.26rem;margin-left: 0.1rem;" @click="readAgrementChange">我已阅读并同意<em style="color:#DF8366">《大学掌用户服务协议及隐私政策》</em></span>
          </div>
          <!--温馨提示-->
          <div v-if="tip">
            <div v-html="tip" class="rich-text-container"></div>
          </div>
          <div v-else>
            <div class="rich-text-container" v-if="vueType == 'kd' ">
              <p style="margin:0.1rem  0;">温馨提示：</p>
              请选择<span style="color: #D84444; font-weight: bolder;">学校+运营商</span> 后即可查看校园网具体<span
                style="color: #D84444; font-weight: bolder;">开通条件</span>，如有疑问，可随时通过微信公众号【大学掌】咨询，感谢您的支持！
            </div>
            <div class="rich-text-container" v-if="vueType == 'yx' ">
              <p style="margin:0.1rem  0;">温馨提示：</p>
              请选择<span style="color: #D84444; font-weight: bolder;">学校+运营商</span> 即可查看所在校区<span
                style="color: #D84444; font-weight: bolder;">优惠详情</span>，如有疑问，可随时通过微信公众号【大学掌】咨询，感谢您的支持！
            </div>
            <div class="rich-text-container" v-if="vueType == 'kk' ">
              <p style="margin:0.1rem  0;">温馨提示：</p>
              请选择<span style="color: #D84444; font-weight: bolder;">学校+运营商</span> 即可查看所在校区<span
                style="color: #D84444; font-weight: bolder;">开卡详情</span>，如有疑问，可随时通过微信公众号【大学掌】咨询，感谢您的支持！
            </div>
          </div>
        </div>
        <div style="height: 1.3rem" :class="focus ? 'height1' : ''"></div>
        <!--支付-->
        <van-submit-bar :price="suprprice" label="总计：" text-align="left" style="z-index: 1" :class="focus ? 'toBar' : ''">
          <template slot="button">
            <van-button :disabled="!(formList && formList.length > 0)" type="primary" @click="payShow"
                        style=" min-width: 2.8rem; max-width: 2.8rem; border-radius: 0;height: 100%;"
                        :color=" vueType == 'yx' ? 'linear-gradient(to right, #FF691A, #EF8C05)' : 'linear-gradient(to right, #0d4bed, #0293fc)'">立即开通
            </van-button>
          </template>
        </van-submit-bar>

        <!--支付方式-->
        <pay v-if="showPayMethod" :price="form.suprprice" @pay="payPrice" @close="showPayMethod = false"/>
      </van-form>
    </div>
    <iframe v-else :src="iframeUrl" style="width: 100vw; height: 90vh" frameborder="0"></iframe>
    <!--    图形验证码-->
    <div class="task" v-if="taskShow">
      <div class="imgCode">
        <img class="close" src="@/assets/img/close.png" @click="close">
        <h1><img src="@/assets/img/yzm.png" alt=""><span>请按照图形输入字母或数字</span></h1>
        <div class="imgCodeCon">
          <van-field v-model="imgCode" placeholder="请输入验证码" class="txt"></van-field>
          <img :src="myImgsrc" @click="getTCode">
        </div>
        <van-button :loading="loadingg" loading-type="spinner" loading-text="加载中..." @click="getCode"
                    style=" height: 50px; width: 100%; border-radius: 5px; color: #fff; background: linear-gradient(to right, #0d4bed, #0293fc);"
        >确定
        </van-button>
        <p class="des">点击图形即可刷新验证码</p>
      </div>
    </div>
    <!-- 5G说明 -->
<!--    <van-popup
        v-model="show5g"
        style="background: none;"
    >
      <div style="position: relative;height: 72vh;">
        <div style="width: 86vw;height: 65vh;overflow: auto;border-radius: 12px;">
          <img style="width: 100%" src="@/assets/img/5G-bg.png" />
        </div>
        <van-icon name="close" color="#c8c9cc" size=".56rem" style="font-weight: bold;position: absolute;bottom: 0;left: 45%;"/>
      </div>
    </van-popup>-->
    <van-dialog v-model="show5g" confirmButtonText="关闭" closeOnClickOverlay confirmButtonColor="#0178ef">
      <div style="width: 100%;height: 65vh;overflow: auto">
        <img style="width: 100%;display: block;" src="@/assets/img/5G.jpg" />
      </div>
    </van-dialog>
    <!--  提交宽带方式温馨提示  -->
    <van-dialog v-model="certdocktypeShow" show-cancel-button
                :message="certdocktypeTips"
                @cancel="certdocktypeCancel"
                @confirm="certdocktypeConfirm"
                cancel-button-text="创建新账号" confirm-button-text="覆盖原有账号">
      <template slot="title">
        <div>温馨提示</div>
        <p style="position: absolute;right:15px;top:12px" @click="certdocktypeShow = false">
          <img style="width: 14px;" src="@/assets/img/close.png" alt="">
        </p>
      </template>
    </van-dialog>
  </div>
</template>

<script>
import Pay from "@/components/Pay";
import commonApi from "@/api/common";
import {Dialog} from 'vant';

export default {
  name: "PageForm",
  components: {
    Pay,
  },
  props: {
    // 接口前缀地址
    url: String,
    // 支付结果路由名称
    resultRouterName: String,
    // 业务类型 (kd 宽带 kk 开卡 yx 营销) // TODO 每个模块有多不同的可以根据属性值判断
    businessType: String
  },
  data() {
    return {
      show: true,
      bgImg: require("@/assets/img/home-bg.png"),
      activeIcon: require("@/assets/img/checked.png"),
      inactiveIcon: require("@/assets/img/check.png"),
      textTitle: '',
      form: {
        formid: "", // 表单id
        schcode: "", // 学校编号
        seloper: "", // 运营商
        telephone: "", // 手机号
        smsCode: "",
        iswithno: "0", // 开启携号转网
        suprcode: "", // 产品编码
        suprname: "", // 产品名称
        suprprice: 0, // 产品金额
        username: "", // 姓名
        paytype: "", // 支付方式
        acticode: "", // 活动编号
        actiname: "", // 活动名称
        extend: {
          subsource: this.$common.getQueryString("source") || null, // source 提交来源
          stuno: "", // 学号
          idcard: "", // 身份证号
          room: "", // 宿舍楼
          roomnum: "", // 房间号
          serpwd: "", // 服务密码
          netpwd: "", // 上网密码
          enrolledyear: '', // 入学年限
          handleType: '', // 办理方式
          enable5g: '1', // 是否开通5G双域
          wxopenid: (localStorage.getItem("openId") && localStorage.getItem("openId") != 'null') ? localStorage.getItem("openId") : null, // openId
          wxunionid: (localStorage.getItem("unionId") && localStorage.getItem("unionId") != 'null') ? localStorage.getItem("unionId") : null, // unionId
          extensionid: this.$common.getQueryString("exte") || null, // 推广id
        },
      },
      defaultCheckTxtShow: false,
      suprprice: 0, // 支付金额
      // 默认校验
      schcodeShow: false,
      seloperShow: false,
      telephoneShow: false,
      telephoneGs: false,
      suprcodeShow: false,
      readAgrement: false, // 阅读协议
      // 动态表单数据
      formList: [],
      showPicker: false,
      // 校区列表
      campusList: [],
      // 校区下拉
      showCampus: false,
      // 宿舍楼列表
      dormitoryList: [],
      // 产品列表
      productList: [],
      // 产品下拉
      showProduct: false,
      // 入学年限
      showEnrolledyear: false,
      // y运营商数据
      operatorsList: [],
      // 宿舍楼列表
      schoolroomList: [],
      // 宿舍楼
      showSchoolroom: false,
      // 运营商下拉
      showOperator: false,
      remaSchoolName: "",
      getCodeShow: false,
      // 下拉选中名称展示
      campusName: "", // 校区名称
      schoolroomName: "", //宿舍楼名称
      selectedschoolroom: "", // 当前选中的宿舍楼名称
      operatorsName: "", // 运营商名称
      productName: "", // 产品名称
      // 支付方式选择
      showPayMethod: false,
      // 订单id
      ordecode: "",
      // 判断支付状态
      timer: "",
      iframeUrl: "",
      // 温馨提示
      tip: "",
      // 当前业务类型
      vueType: this.businessType,
      // 手机验证码
      vcodeCheck: false,
      acti: this.$common.getQueryString("acti") || null, // 活动code
      scho: this.$common.getQueryString("scho") || null, // 学校code
      prod: this.$common.getQueryString("prod") || null, // 产品编号
      kddi: this.$common.getQueryString("kddi") || null, // 运营商
      loadingg: false,
      taskShow: false, // 图形验证码是否显示
      imgCode: '', // 图形验证码输入框
      myImgsrc: '', // 验证码图形
      focus: false, // 手机号输入框是否获取焦点
      // 是不是展示5g弹窗
      show5g: false,
      // 宽带提交运营商提示
      certdocktypeShow: false,
      certdocktypeTips: '检测到您已拥有当前运营商的宽带账号，新预约宽带是否覆盖原有宽带账号？'
    };
  },
  mounted() {
  },
  created() {
    this.getActiDetails();
    this.getEnrolledyear();
    this.getVueType();
    this.getCampus();
  },
  watch: {},
  computed: {},
  methods: {
    defalutFocus(){
      this.focus = true
    },
    /* 获取活动详情 */
    getActiDetails () {
      let acti = this.acti;
      let url = `${this.url}getActivity/${acti}`;
      this.axios.get(url)
          .then((res) => {
            if (res.data.code === 0) {
              if (res.data.data.acexplain) {
                this.tip = res.data.data.acexplain;
              }
            } else {
              this.$toast.fail(res.data.msg);
            }
          });
    },
    /* 获取当前年往前推5年 */
    getEnrolledyear () {
      let yearList = commonApi.getEnrolledyear(5);
      return yearList;
    },
    /* 选择入学年限 */
    onConfirmEnrolledyear (val) {
      this.form.extend.enrolledyear = val;
      this.showEnrolledyear = false;
      if (this.getIndex("enrolledyear")) {
        this.formList[this.getIndex("enrolledyear")].value = this.form.extend.enrolledyear;
      }
    },
    /* 根据当前业务类型进行title切换 */
    getVueType() {
      const type = this.vueType;
      if (type == 'kk') {
        this.bgImg = require("@/assets/img/opencard.png");
        this.textTitle = '开卡业务'
      } else if (type == 'yx') {
        this.bgImg = require("@/assets/img/yx.png");
        this.textTitle = '营销业务'
      } else if (type == 'kd') {
        this.bgImg = require("@/assets/img/home-bg.png");
        this.textTitle = '校园网业务'
      }
    },
    /* 获取校区 */
    getCampus() {
      if (!this.acti) {
        return this.$toast.fail("活动不能为空");
      }
      let url = this.url + "selectSchool";
      this.axios
          .get(url, {
            params: {
              acti: this.acti,
              scho: this.scho,
              prod: this.prod,
            },
          })
          .then((res) => {
            if (res.data.code === 0) {
              this.campusList = res.data.data;
              /**
               * 如果返回数据未一条直接 默认第一条
               * **/
              if (res.data.data && res.data.data.length == 1) {
                this.onConfirmCampus(res.data.data[0])
              }
            } else {
              this.$toast.fail(res.data.msg);
            }
          });
    },
    /* 确认选择校区 */
    onConfirmCampus(obj) {
      this.defaultCheckTxtShow = true;
      this.campusName = `${obj.locate}`;
      this.form.schcode = `${obj.locatecode}`;
      this.schcodeShow = false;
      if (this.operatorsName) {
        this.operatorsName = "";
        this.form.seloper = "";
      }
      if (this.productName) {
        this.productName = "";
      }
      this.showCampus = false;
      this.getOperators(obj.locatecode);
      this.getRoomList(obj.locatecode);
      // 表单信息
      if (this.isGetMsg()) {
        this.getForm(this.isGetMsg());
        this.getProduct(this.isGetMsg());
      } else {
        this.formList = [];
      }
    },
    /* 获取运营商 */
    getOperators(schocode) {
      let url = this.url + "selectoper";
      this.axios
          .get(url, {
            params: {
              schocode: schocode,
              acti: this.acti,
              kddi: this.kddi,
              prod: this.prod,
            },
          })
          .then((res) => {
            if (res.data.code === 0) {
              let list = res.data.data;
              let arry = [];
              list.forEach((e) => {
                let obj = {
                  value: e,
                  label: commonApi.getOperatorsLabel(e),
                };
                arry.push(obj);
              });
              this.operatorsList = arry;
              if (arry.length == 1) {
                this.onConfirmOperators(arry[0])
              }
            } else {
              this.$toast.fail(res.data.msg);
            }
          });
    },
    /* 确认选择运营商 */
    onConfirmOperators(obj) {
      this.getCodeShow = false
      this.defaultCheckTxtShow = true;
      this.operatorsName = `${obj.label}`;
      this.form.seloper = `${obj.value}`;
      this.seloperShow = false;
      if (this.productName) {
        this.productName = "";
      }
      // 表单信息
      if (this.isGetMsg()) {
        this.getForm(this.isGetMsg());
        this.getProduct(this.isGetMsg());
      } else {
        this.formList = [];
      }
      this.showOperator = false;
    },
    /* 获取宿舍楼 */
    getRoomList(schocode) {
      let url = this.url + "selectSchoolroom";
      this.axios
          .get(url, {
            params: {
              schocode: schocode,
              prod: this.prod,
            },
          })
          .then((res) => {
            if (res.data.code === 0) {
              this.schoolroomList = res.data.data;
              if (res.data.data.length == 1) {
                this.onConfirmSchoolroom(res.data.data[0])
              }
            } else {
              this.$toast.fail(res.data.msg);
            }
          });
    },
    /* 确认选择宿舍楼 */
    onConfirmSchoolroom(obj) {
      this.selectedschoolroom = {...obj};
      this.defaultCheckTxtShow = true;
      this.schoolroomName = obj.room;
      this.form.extend.room = obj.room;
      if (this.getIndex("dormitory")) {
        this.formList[this.getIndex("dormitory")].value = this.form.extend.room;
      }
      this.showSchoolroom = false;
    },
    /* 获取表单信息 */
    /**
     * 备注：表单信息获取（运营商和学校两个同时存在监听变化时就请求）  ———— 必须有运营商和学校信息
     * **/
    getForm(obj) {
      this.formList = [];
      let url = this.url + "selectFrom";
      this.axios
          .get(url, {
            params: obj,
          })
          .then((res) => {
            if (res.data.code === 0) {
              if (res.data.data) {
                this.form.formid = res.data.data.id;
                this.formList = res.data.data.fieldcontent
                    ? JSON.parse(res.data.data.fieldcontent)
                    : [];
                console.log('formList', this.formList)
                if (!this.formList && this.formList.length > 0) {
                  this.$toast.fail("表单设置有误");
                }
                if (this.form.extend.room && this.getIndex("dormitory")) {
                  this.formList[this.getIndex("dormitory")].value = this.form.extend.room;
                }
                /* 是否开通5G双域默认值 */
                if (this.getIndex("enable5g")) {
                  this.formList[this.getIndex("enable5g")].value = '1'
                }
              }
            } else {
              this.$toast.fail(res.data.msg);
            }
          });
    },
    /* 根据运营商和学校获取信息 */
    isGetMsg() {
      if (this.form.schcode && this.form.seloper) {
        let obj = {
          schocode: this.form.schcode,
          oper: this.form.seloper,
          acti: this.acti,
          prod: this.prod,
        };
        return obj;
      } else {
        return false;
      }
    },
    /* 点击选择产品 */
    /**
     * 备注：产品信息获取（点击选择产品表单时获取信息）  ———— 必须有运营商和学校信息
     * **/
    clickProduct() {
      if (this.isGetMsg()) {
        // this.getProduct(this.isGetMsg());
        this.showProduct = true;
      } else {
        if (!this.form.schcode) {
          this.schcodeShow = true;
        }
        if (!this.form.seloper) {
          this.seloperShow = true;
        }
      }
    },
    /* 获取产品 */
    getProduct(obj) {
      let url = this.url + "selectProduct";
      this.axios
          .get(url, {
            params: obj,
          })
          .then((res) => {
            if (res.data.code === 0) {
              this.productList = res.data.data;
              /**
               * 如果返回数据未一条直接 默认第一条
               * **/
              if (res.data.data.length == 1) {
                this.showProduct = true;
                this.onConfirmProduct(res.data.data[0])
              }
            } else {
              this.$toast.fail(res.data.msg);
            }
          });
    },
    /* 确认选择产品 */
    onConfirmProduct(obj) {
      this.productName = `${obj.name}`;
      this.form.suprcode = obj.code;
      this.form.suprname = obj.name;
      this.form.suprprice = obj.price;
      this.form.acticode = obj.braccode;
      this.form.actiname = obj.bracname;
      this.suprcodeShow = false;
      this.suprprice = obj.price * 100;
      this.tip = obj.suexplain;
      this.showProduct = false;
    },
    /*获取图形验证码*/
    getTCode(){
      if (!this.form.telephone) {
        return this.$toast.fail("手机号不能为空");
      } else {
        let url = `/basics/smsvalidecode/captcha-code/${this.form.telephone}`;
        this.axios({
          baseURL: this.$baseUrl.baseUrl,
          method: 'get',
          url: url,
          responseType: 'blob', // 防止下载内容的出现乱码
        })
            .then((res) => {
              this.taskShow = true
              let blob = new Blob([res.data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8',
              })
              let imageUrl = window.URL.createObjectURL(blob);
              console.log("imageUrl:",imageUrl);
              this.myImgsrc = imageUrl;
            });
      }
    },
    /*关闭图形验证码*/
    close(){
      this.taskShow = false
    },
    /* 获取验证码 */
    getCode() {
      if (!this.form.telephone) {
        return this.$toast.fail("手机号不能为空");
      }
      this.loadingg = true;
      // let url = `/basics/smsvalidecode/code/${this.form.telephone}?captchaCode=${this.imgCode}`;
      let url = `/basics/smsvalidecode/code/${this.form.telephone}`;
      this.axios.get(url).then((res) => {
        this.loadingg = false;
        if (res.data.code === 0) {
          this.getCodeShow = true;
          this.$nextTick(() => {
            this.$refs.countDown[0].start();
            this.$toast.success("验证码已发送手机，请注意查收！");
            this.taskShow = false
          });
        } else {
          this.$toast.fail(res.data.msg);
        }
      });
    },
    /* 倒计时结束 */
    finish() {
      this.getCodeShow = false;
    },
    /* 验证码验证 验证6位数*/
    vcodeBlur(val, item) {
      item.checkTxtVcode = '';
      if (!val) {
        item.checkTxt = '验证码不能为空';
        return false;
      }
      if (val.length == '6') {
        this.axios.post('/basics/smsvalidecode/code/check', {
          code: val,
          phone: this.form.telephone
        })
            .then(res => {
              if (res.data.code === 0) {
                this.$toast.success('验证码验证通过');
                this.vcodeCheck = true;
              } else {
                this.vcodeCheck = false;
                item.value = '';
                item.checkTxtVcode = res.data.msg;
                this.$toast.fail(res.data.msg);
              }
            });
      } else {
        item.checkTxt = '请输入正确的验证码';
        return false;
      }
    },
    /**
     * 提交表单  及表单校验
     * **/
    /* 表单默认项校验 （校区 运营商  手机号） */
    defaultFormCheck() {
      if (!this.form.schcode) {
        this.schcodeShow = true;
      } else {
        this.schcodeShow = false;
      }
      if (!this.form.seloper) {
        this.seloperShow = true;
      } else {
        this.seloperShow = false;
      }
      if (!this.form.telephone) {
        this.telephoneShow = true;
      } else {
        this.telephoneShow = false;
      }
      if (!this.form.suprcode) {
        this.suprcodeShow = true;
      } else {
        this.suprcodeShow = false;
      }
      if (this.isGetMsg() && this.form.telephone && this.form.suprcode) {
        return true;
      }
    },
    /* 默认项手机号失去焦点 */
    defaultBlur(val) {
      this.focus = false
      if (!val) {
        this.telephoneShow = true;
      } else {
        this.telephoneShow = false;
        const reg = /^1[0-9]{10}$/;
        if (!reg.test(val)) {
          this.telephoneGs = true;
        } else {
          this.telephoneGs = false;
        }
      }
      // 切换手机号清空验证码防止提交表单手机号验证码不匹配
      this.formList[this.getIndex("verifycode")].value = '';
      this.vcodeCheck = false;
    },
    /* 动态表单失去焦点 */
    blurField(item) {
      item.checkTxt = "";
      // 必填项校验
      if (item.required && !item.value && item.show) {
        item.checkTxt = this.requiredCheck(item);
      }
      if (!item.show) {
        item.value = '';
      }
      // 正则校验
      if (item.regular && item.value && !this.patternCheck(item)) {
        item.checkTxt = item.describe + "格式不正确";
      }

      // 宿舍号
      if (item.id === "roomnum" && this.selectedschoolroom && item.value) {
        if (this.selectedschoolroom.nummax !== null && this.selectedschoolroom.nummin === null) {
          item.checkTxt = item.value.length <= this.selectedschoolroom.nummax ? "" : `宿舍号最大长度为${this.selectedschoolroom.nummax}`;
        } else if (
            this.selectedschoolroom.nummax === null && this.selectedschoolroom.nummin !== null
        ) {
          item.checkTxt = item.value.length >= this.selectedschoolroom.nummin ? "" : `宿舍号最小长度为${this.selectedschoolroom.nummin}`;
        } else if (
            this.selectedschoolroom.nummax !== null && this.selectedschoolroom.nummin !== null
        ) {
          item.checkTxt = item.value.length >= this.selectedschoolroom.nummin && item.value.length <= this.selectedschoolroom.nummax ? "" : `宿舍号的长度范围为${this.selectedschoolroom.nummin} - ${this.selectedschoolroom.nummax}`;
        }
      }
    },
    /* 必填项校验 */
    requiredCheck(item) {
      return `${item.fieldName}不能为空`;
    },
    /* 正则校验 */
    patternCheck(item) {
      let regular = new RegExp(item.regular);
      return regular.test(item.value);
    },
    /* 协议内容 */
    readAgrementChange() {
      Dialog.alert({
        title: '大学掌用户服务协议及隐私政策',
        message: '尊敬的用户，欢迎您使用由河南安冉云网络科技有限公司提供的校园无线网络接入服务。<br>&nbsp; &nbsp; &nbsp; &nbsp; 本协议是您（或称“用户”）与河南安冉云网络科技有限公司(以下简称 “安冉云”) 之间就校园无线网络接入服务所订立的契约。<span class="black bold">在通过学校系统提供的学号 工号登录接入本校园无线网络前，请您仔细阅读本协议的全部内容，特别是协议中以加粗字体显示的内容， 您应重点阅读。</span>如您对协议有任何疑问，可向安冉云咨询。<span class="bold black">如果您不同意本协议或其中任何条款约定，请您立即停止登录；您点击"同意"按钮后，本协议即构成对双方有约束力的法律文件。</span><br> 一、 定义<br>    1、本网络：在本协议中除非专门指明或声明，均指由安冉云所有并负责运营的校园无线网络。<br>    2、所有权以及相关的权利：在本服务协议中，除非专门指明或声明，均意味着：第一，所有权；第二，知识产权，包括但不限于著作权、专利权、商标权、商业秘密等；第三，除上述权利之外的对物、信息及其载体和表现形式的使用、利用、传播、复制、发行、编辑、修改、处分等权利。<br>    3、用户：在本服务协议中，除非专门指明或声明，是指接受本服务协议的自然人、法人或其他组织。<br>4、个人信息：在本服务协议中，除非专门指明或声明，是指以电子或者其他方式记录的能够单独或者与其他信息结合识别用户身份或者反映用户活动情况的各种信息。<br>    5、网络服务：指本客户端基于互联网方式向用户提供的业务宣传、业务查询、业务办理、交费充值、商品交易、信息分享等服务。<br>    6、本公司：在本协议中，除非专门指明或声明，是指河南安冉云网络科技有限公司。<br>    7、“大学掌”微信公众号：在本协议中，除非专门指明或声明，是指由河南安冉云网络科技有限公司所有的、与校园无线网络相关的名为“大学掌”的微信公众号。<br><br>    二、 网络服务内容<br>    1、本网络向校园用户提供的网络服务包括：<br>    （1）用户预约、办理、开通、登录、安全退出、找回密码、修改密码、客服咨询等服务；<br>    （2）“大学掌”微信公众号业务办理服务；<br>    （3）发布的文字、软件、声音、图片、录像、图表、广告中的全部内容；<br>    （4）“大学掌”微信公众号消息通知服务；<br>    （5）信息发布与分享；<br>    （6）本网络为用户提供的其他服务。<br>    2、本网络有权根据各类情况变化而调整网络服务的具体内容，“大学掌”微信公众号提供的    自助业务办理功能以及发布的信息随时都有可能发生变动，对此安冉云不作特别通知，也不对网络服务的提供或不提供作出承诺。<br>    3、本网络仅提供校园无线网络服务，与网络服务有关的通信设备（如电脑、调制解调器及其他与接入互联网有关的装置）及通信服务所需的费用（如未接入互联网而支付的电话费及宽带费）由用户自行承担。<br><br>    三、 权利声明<br>    1、任何本网络及“大学掌”微信公众号所发布的信息及/或其载体，及/或其表现形式，及/或服务，除以下情况之外，其所有权及相关的权利均独占性地属于安冉云所有：<br>    （1）依据中华人民共和国的相关法律规定该信息及/或载体，及/或服务，不享有所有权以及与此相关的权利的;<br>    （2）依据安冉云和其他主体之间的协议、合同、章程，由安冉云和其他主体共享，或其他    主体单独享有或安冉云转让的；<br>    （3）依据安冉云具有法律效力的正式声明而放弃的。<br><span class="black bold">        2、用户只能在本网络的提供者授权下才能使用由本网络享有权利的内容，且无权擅自复制、修改这些内容，或创造与内容有关的派生产品。任何对本客户端享有的基于该信息及/或其    载体，及/或其表现形式，及/或服务的权利的侵犯，均属于对本网络运营等权利的侵犯。</span><br>    四、用户账号注册与管理<br>    1、用户在完成预约办理或登录程序实际使用本网络提供的服务时，应当是具备完全民事权利能力和完全民事行为能力的自然人、法人或其他组织或可以做出与其年龄、智力相适应行为的的限制民事行为能力人。若用户不具备前述主体资格，则用户及用户的监护人应当依照法律规定承担因此而导致的一切后果，安冉云有权注销或永久冻结您的账户。<br>    2、如果您是与安冉云合作院校的学生，在学校主管部门授权或学校相关提供学号后，可以使用学号为账号进行登录；在完成激活或验证流程时，您应当按照相应页面的提示提供您的身份信息及资料，您应保证提供的身份信息及资料真实、及时、完整和准确。<br>    3、您在本网络使用中设置的相应信息不得违反国家法律法规关于互联网用户账号信息等的管理规定，否则本网络将有权回收您的账户。<br>    4、您在使用本网络时的账号、密码和手机号码、学号等是您在本网络的唯一身份权证。为享受本网络提供的网络服务，您须按照对应的服务要求键入正确的用户账号及密码或短信验证码。<br>    5、您应保管好自己在本网络的使用的账号、密码和手机短信验证码，避免使用过于简单的密码。您在服务使用过程中可以根据本网络规定更改密码。非经本网络事先同意，账号和密码不得出借、转让、继承或者赠与。非因本网络原因导致您的账号、密码遗失、遗忘或被他人窃取的，本网络不承担责任。如果您发现自己的个人信息泄密，尤其是本校园网络账户及密码发生泄露，请您立即联络安冉云。<br><span class="bold black">        6、用户通过账号+密码和/或手机短信验证码登录后使用本网络进行的一切行为以及办理的一切业务，均视为用户亲自办理的业务或实施的行为，由用户承担因此所导致的相关后果和责任，包括但不限于业务费用的支付和相应的法律责任。<br></span>    7、安冉云将在业务范围内，合理的采取相应的措施来保证用户的帐户和使用安全，但安冉云不保证其绝对安全。<br><br><span class="black bold">        五、用户权利及其限制<br>    1、在遵守本服务协议的前提下，用户有权享有本网络提供的校园无线网络服务，并将收到“大学掌”微信公众号发布的相关服务的相关信息。<br>    2、用户通过本网络及“大学掌”微信公众号发表的信息为可能会成为公开的信息，其他第三方均有可能通过本网络合法的获取用户发表的信息，用户对任何信息的发表即认可该信息可以成为公开的信息，并单独对此行为承担法律责任；任何用户不愿被其他第三人获知的信息都不应该在本网络上进行发表。<br>    3、用户承诺对网络服务的使用以及安冉云提供相应配套服务中的各项行为应符合国家法律法规的规定，且行为符合下列要求：<br>    （1）从中国境内向境外传输技术性资料时必须符合中国有关法律的规定；<br>    （2）不传输或发表：煽动抗拒、破坏宪法和法律、行政法规实施的言论，煽动颠覆国家政权，推翻社会主义制度的言论，煽动分裂国家、破坏国家统一的言论，煽动民族仇恨、民族歧视、破坏民族团结的言论；<br>    （3）不传输或发表任何违法犯罪的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、伤害性的、庸俗的，淫秽的、不文明的等信息资料；<br>    （4）不得传输或发表违背公序良俗和涉及国家安全的信息资料或言论；<br>    （5）不干扰本客户端的正常运转，不得侵入本客户端及国家计算机信息系统；<br>    （6）不得发布任何侵犯他人著作权、商标权等知识产权或隐私权、名誉权等合法权益的内容；<br>    （7）遵守所有使用网络服务的网络协议、规定、程序和惯例；<br>    （8）使用网络服务不作非法用途；<br>    &nbsp; &nbsp; &nbsp; &nbsp; 若用户未遵守以上规定的，须对自己在网上的言论和行为承担法律责任，且安冉云有权作出独立判断并采取暂停或关闭用户帐号服务、追究其刑事责任等措施。<br>    4、本网络对用户发布及通过本网络从事的任何活动、传送的任何内容不承担责任，用户需对自己在网上的行为承担一切法律责任。用户如使用本网络从事、发布涉嫌违法或涉嫌侵犯他人合法权利或违反本协议的信息，本网络有权不经通知用户即予以删除并对账户进行黑名单记录。用户如有散布和传播反动、色情或其他违反国家法律信息的活动，本网络的系统记录将作为用户违反法律的证据，本网络也将追究其相应的法律责任。<br>    4、用户违反本协议使用网络服务导致本网络或第三人损失的，因此产生的损害赔偿的责任范围不包括本公司或受伤害的第三方未实现的预期利润或利益、商业信誉的损失、数据的丢失、第三方损失以及其他间接损失、律师费用及其他相关费用，均由该用户承担。<br></span><br>    六、用户个人信息保护<br>    1、 用户应保证自己在预约开通或登录时用户身份的真实性、正确性及完整性，如果相关信息发生变化，用户应及时更改。本网络不能也不会对个人信息的不真实、不准确，或个人信息未及时更新而引起的任何损失或损害承担责任。本网络有权在投诉人或有关单位准确说出用户在预约办理或登录时所用的手机号码、身份证号码和用户姓名后删除该用户，并不承担任何责任。遇此情况，请用户重新办理本网络业务。<br>    2、用户未能按照本网络的要求和内容提供本人必要信息的，本公司有权中止本网络所提供的服务，由此所导致的任何已经或可能发生的损失，本网络概不负责，并保留对该用户进行追索的权利。本网络有权对用户的登录信息及相关操作进行查阅，发现登录信息或相关操作中存在任何问题或怀疑，均有权向用户发出询问及要求改正的通知或者直接作出删除账户等处理。<br>    3、安冉云非常重视用户个人信息的保护，在您使用安冉云提供的本网络服务时，您同意安冉云按照在本网络及国家相关规定等公布的隐私政策收集、存储、使用、披露和保护您的个人信息。<span class="bold black">        安冉云希望通过《隐私政策》向您清楚地介绍安冉云对您个人信息的处理方式，因此建议您完整地阅读《隐私政策》，以帮助您更好地保护您的个人信息。<br><br>    七、免责声明<br>    1、本网络不就通信系统或不可抗力的互联网的中断或无法运作、技术故障、计算机错误或病毒、信息损坏或丢失或其它在本网络合理控制范围之外的原因而产生的其他任何性质的破坏而向用户或任何第三方承担赔偿责任。<br>    2、本网络需要定期或不定期地对相关的信息网络系统、设备进行检修、维护或升级，如因此类情况而造成网络服务在合理时间内的中断，本公司无需为此承担任何责任，但安冉云将尽可能通过“大学掌”微信公众号或采取其他途径事先进行通知。<br>    3、安冉云不保证用户在使用本网络时在操作上不会中断或没有错误，不保证是否会纠正本网络的缺陷，不保证本网络能满足用户的所有要求，亦不保证用户能通过本网络进行任何的业务，对网络服务的及时性、安全性、准确性也都不作担保。<br>    4、用户通过本网络进行交易、获取有偿服务而发生的所有税费及有关费用，均由用户负责支付，因此产生的风险也由用户个人承担。安冉云提醒用户应该通过自己的谨慎判断确定陈列商品及相关信息的真实性、合法性和有效性。<br>    5、因不可抗力事件包括但不限于如地震、山洪、雷电及其他自然灾害或计算机病毒，网络瘫痪、国家管控、政调整等造成的本网络服务质量下降、中断等而使本协议部分或全部不能履行，安冉云不承担相应的责任。<br>    6、在法律允许的范围内，因有关单位或司法机关的相关需求，安冉云对向其发送的相应客户个人信息不承担泄密或违约的责任。<br>    7、双方承认本条款反映了双方就协商谈判达成的一致意见。双方均完全了解本条款的后果并进一步承认本条款的合理性。<br></span><br>    八、网络服务的停止<br>    1、在以下情形下，本公司有权单方并在不做出任何通知的情况下立即停止对用户提供本网络服务:<br>    （1）若该用户是通过手机号码及短信验证码登陆的，当该用户所对应绑定的的手机号码停机或销号后；<br>    （2）用户违反本协议规定使用网络服务；<br>    （3）用户提供的注册资料不真实；<br>    （4）用户账户被删除后；<br>    2、用户对本协议后续的修改有异议，或对本网络的服务不满，可以行使如下权利：<br>    （1）停止使用本公司提供的的本网络服务；<br>    （2）通告本公司停止对该用户的本网络服务；<br>    3、用户服务停止后，本公司没有义务向该用户或第三方传送任何未处理的信息或未完成的服务，亦无需对该用户或第三方负责。但本协议的终止并不意味着终止前所发生的未完成用户指令的撤销，也不能消除因终止前的交易所带来的法律后果。<br><br>    九、通告<br>&nbsp; &nbsp; &nbsp; &nbsp; 所有发给用户的通告都可通过“大学掌”微信公众号页面的公告或电子邮件或常规的信件传送。服务条款的修改、服务变更、或其它重要事件的通告都会以此形式进行。<br><br>    十、服务条款修改<br>    &nbsp; &nbsp; &nbsp; &nbsp; 本网络有权根据法律法规变化和运营需要，对本协议条款不时地进行修改。本协议一旦发生变动，本网络将通告用户，修改后的协议一经通告即生效。用户如果不同意所改动的内容，应主动停止使用本客公司提供的本网络服务。如果用户继续享用本网络服务，则视为接受服务条款的变动。<br><br>    十一、法律<br>    1、本协议条款适用中华人民共和国的法律法规。如协议条款与中华人民共和国法律相抵触，    则依照法律的规定重新解释该服务条款，但不影响其它条款的法律效力和影响。<br>2、本协议的订立、执行和解释及争议的解决均应适用中华人民共和国法律并受中华人民共和国法院管辖。<br>    3、用户与本客户端一致同意：<br>    （1）双方应持平等、友好、争取合理解决问题的态度；<br>    （2）发生纠纷时首先以协商方式解决，如协商未果，任何一方应向安冉云所在地人民法院提起诉讼。<br><br>    十二、其他<br>    1、安冉云未行使本协议的任何权利或规定，并不构成对前述权利之放弃。<br>2、如本协议中的任何条款完全或部分无效，本协议的其余条款仍有效并且有约束力。<br>3、本协议内容包括协议正文及“大学掌”微信公众号上发布的声明和规则，包括但不限于办理指南、服务说明、隐私政策等。所有声明、政策和规则等与协议正文具有同等法律效力，共同构成完整的服务协议。<br><br><span class="black bold">        十三、用户承诺<br>&nbsp; &nbsp; &nbsp; &nbsp; 用户承诺已详细阅读本协议的全部条款，用户在勾选已阅读本协议内容的选项后，本协议即视为完全理解并同意接受本协议的全部条款。<br></span><span class="bold black">&nbsp; &nbsp; &nbsp; &nbsp;以下为我司有关个人信息保护的政策，请您查阅。</span><br><h2 class="title black">《隐私政策》</h2>&nbsp; &nbsp; &nbsp; &nbsp;安冉云非常重视您的个人信息保护，并会尽全力保护您的个人信息安全可靠。本政策适用于    安冉云所提供的校园无线网络服务，请您在使用本网络服务前，仔细阅读并了解本《个人信息保护政策》。<br>    一、我们如何收集和使用您的个人信息<br>    &nbsp; &nbsp; &nbsp; &nbsp; 个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。<br>&nbsp; &nbsp; &nbsp; &nbsp;安冉云仅会出于本政策所述的以下目的，收集和使用您的个人信息：<br>    （一）为更好地为您提供服务，安冉云将遵循“合法、正当、必要”原则，按照法律法规的规定和您的同意收集您的个人信息，主要包括：<br>    1、您提供的信息<br>&nbsp; &nbsp; &nbsp; &nbsp; 您注册成为我们的用户或使用我们的服务时，向我们提供的相关个人信息，包括您的姓名（名称）、性别、年龄、地址、学号、电话号码、电子邮箱、身份证件号码、缴费相关的银行信息以及联系人信息等。<br>&nbsp; &nbsp; &nbsp; &nbsp;您提供的上述信息，将在您使用本网络服务期间持续授权我们使用。在您注销账号时，我们将停止使用上述信息。<br>    2、您在使用服务过程中产生的信息。<br>&nbsp; &nbsp; &nbsp; &nbsp;您使用我们提供的服务时，我们可能自动收集以下信息：<br>（1）日志信息<br>&nbsp; &nbsp; &nbsp; &nbsp; 指您使用我们的服务时，系统可能通过 cookies、web beacon 或其他方式自动采集的技术信息，包括：<br>    A. 设备或软件信息，例如您的移动设备、网页浏览器或您用于接入我们的服务的其他程序所提供的配置信息、您的 IP 地址和您的移动设备所用的版本和设备识别码；<br>    B. 您在使用我们的服务时搜索和浏览的信息，例如您使用的搜索关键字、访问页面，以及您在使用我们的服务时浏览或要求提供的其他信息；<br>    （2）位置信息<br>&nbsp; &nbsp; &nbsp; &nbsp;指您开启设备定位功能并使用我们基于位置提供的相关服务时，我们收集的有关您位置的信息，例如您通过具有定位功能的移动设备使用我们的服务时，我们通过 GPS 或 WiFi 等方式收集的您的地理位置信息。您可以通过关闭定位功能随时停止我们对您的地理位置信息的收集。<br>    （3）订购信息<br>&nbsp; &nbsp; &nbsp; &nbsp; 指您通过“大学掌”微信公众号订购运营商宽带业务、运营商产品及其他增值服务或购买商品时产生的记录，如订购关系记录、消费记录等。<br>    （4）账户信息<br>&nbsp; &nbsp; &nbsp; &nbsp; 指您的登录账户的信息，例如在您选择使用学号或手机账号登录我们的服务时，我们会获取您的学号、手机账号等相关信息。<br>    3、第三方分享的有关您的信息<br>&nbsp; &nbsp; &nbsp; &nbsp; 为给您提供服务，我们可能会从合作院校、关联公司、业务合作伙伴等第三方来源获得您的相关信息。例如当您通过我们合作院校、关联公司、业务合作伙伴客户端、网站订购我们的产品，您向其提供的预订信息可能会转交给我们，以便我们处理您的订单。<br>    （二）我们可能将收集到的您的个人信息用于以下目的：<br>    1、为您提供服务<br>    （1）在我们提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的产品和服务的安全性；<br>    （2）通过信息数据分析，帮助我们设计新服务，改善我们现有服务；<br>（3）使我们更加了解您如何使用我们的服务，从而针对性地满足您的个性化需求，例如语言设定、位置设定、个性化的帮助服务和指示，或对您和其他使用我们服务的用户作出其他方面的回应；<br>    （4）提供您关注或者与您相关的广告以替代普遍投放的广告，您在使用我们的服务时，我们可能使用您的信息向您发送电子邮件、短信或推送通知，如您不希望收到这些信息，可以按照我们的相关提示取消订阅；<br>    （5）评估我们服务中的广告和其他促销及推广活动的效果，并加以改善；<br>    （6）软件认证或管理软件升级；<br>    （7）让您参与有关我们产品和服务的调查；<br>    （8）其他您授权同意提供个人信息的情况。<br>    2、在收集您的个人信息后，我们将通过技术手段对数据进行去标识化处理，去标识化处理的信息将无法识别主体。请您了解并同意，在此情况下我们有权使用已经去标识化的信息；    并在符合相关法律法规的前提下，我们有权对包括您的个人信息在内的用户数据库进行整体化分析和利用。<br>    3、当我们要将信息用于本政策未载明的其它用途时，会事先征求您的同意。<br>    4、您充分知晓，以下情形中我们使用个人信息无需征得您的授权同意：<br>    （1）与国家安全、国防安全有关的；<br>    （2）与公共安全、公共卫生、重大公共利益有关的；<br>    （3）与犯罪侦查、起诉、审判和判决执行等有关的；<br>    （4）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；<br>    （5）所收集的个人信息是个人信息主体自行向社会公众公开的；<br>    （6）从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；<br>    （7）根据您的要求签订合同所必需的；<br>    （8）用于维护所提供的产品与/或服务的安全稳定运行所必需的，例如发现、处置产品与/或服务的故障；<br>    （9）为合法的新闻报道所必需的；<br>    （10）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；<br>    （11）法律法规规定的其他情形。<br><br>    二、我们如何共享、转让、公开披露您的个人信息<br>    （一）共享<br>&nbsp; &nbsp; &nbsp; &nbsp; 我们不会与安冉云以外的任何公司、组织和个人分享您的个人信息，但以下情况除外：<br>    1、在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。<br>    2、我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息。<br>    3、与我们的关联公司共享：您的个人信息可能会与我们的关联公司或合作院校共享。我们只会共享必要的个人信息，且受隐私政策中所声明目的的约束。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意。<br>&nbsp; &nbsp; &nbsp; &nbsp; 我们的关联公司包括安冉云现在或将来控制、受控制或与其处于共同控制下的任何公司、机构以及上述公司或机构的合法继承人。其中“控制”是指直接或间接地拥有影响所提及公司管理的能力，无论是通过所有权、有投票权的股份、合同或其他被人民法院认定的方式。<br>4、与授权合作伙伴共享：仅为实现本政策中声明的目的，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。例如，在您通过我们的客户端购买商品或订购业务时，我们必须与物流服务提供商共享您的个人信息才能安排送货，或者安排合作伙伴提供服务。我们仅会出于合法、正当、必要、特    定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。<br>    目前，我们的授权合作伙伴包括以下三大类型：<br> A.供应商、服务提供商和其他合作伙伴。我们将信息发送给在全球范围内支持我们业务的供应商、服务提供商和其他合作伙伴，这些支持包括提供技术基础设施服务、分析我们服务的使用方式、衡量广告和服务的有效性、提供客户服务、支付便利或进行学术研究和调查。<br>    B.第三方商家。我们必须将您的订单信息与交易有关的必要信息与第三方商家共享来实现您向其购买商品或服务的需求，并促使其可以完成后续的售后服务。<br>    C.广告、分析服务类的授权合作伙伴。除非得到您的许可，否则我们不会将您的个人身份信息（指可以识别您身份的信息，例如姓名或电子邮箱，通过这些信息可以联系到您或识别您的身份）与提供广告、分析服务的合作伙伴分享。但我们可能会将使用您的信息而形成的用户画像与提供广告、分析服务的合作伙伴共享，以帮助在不识别您个人的前提下提升广告及服务信息的有效触达率。<br>&nbsp; &nbsp; &nbsp; &nbsp; 对我们与之共享个人信息的公司、组织和个人，我们会与其签署相应的保密协定，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。<br>    （二）转让<br>&nbsp; &nbsp; &nbsp; &nbsp; 我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：<br>    1、在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；<br>    2、在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。<br>（三）公开披露<br>&nbsp; &nbsp; &nbsp; &nbsp; 我们仅会在以下情况下，公开披露您的个人信息：<br>    1、获得您明确同意后；<br>    2、基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。<br><br>    三、我们如何保护您的个人信息<br>    （一）我们会严格按照《网络安全法》、《全国人民代表大会常务委员会关于加强网络信息保护的决定》、《电信和互联网用户个人信息保护规定》（工业和信息化部令第 24 号）、    《电话用户真实身份信息登记规定》（工业和信息化部令第 25 号）等法律法规的相关要求，建立信息安全保障制度，采取技术措施和其他必要措施保护您的个人信息安全。<br>    （二）我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。<br>    （三）请您理解：互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的任何信息的安全性，但由于技术的限制及可能存在的各种恶意手段，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百安全。在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。<br><br>四、您的权利<br>    1、查询和更正您的个人信息<br>&nbsp; &nbsp; &nbsp; &nbsp; 除法律法规规定外，您有权在登录本网络后查询和更正您的个人信息。<br>    2、在以下情形中，您可以向我们提出删除个人信息的请求：<br>    （1）如果我们处理个人信息的行为违反法律法规；<br>    （2）如果我们收集、使用您的个人信息，却未征得您的同意；<br>    （3）如果我们处理个人信息的行为违反了与您的约定；<br>    （4）如果您不再使用我们的产品或服务，或您注销了账号；<br>    （5）如果我们不再为您提供产品或服务。<br>&nbsp; &nbsp; &nbsp; &nbsp;当您从我们的服务中删除信息后，我们可能不会立即备份系统中删除相应的信息，但会在备份更新时删除这些信息。<br>    3、您注销账户之后，我们将停止为您提供产品或服务，并依据您的要求，删除您的个人信息，法律法规另有规定的除外。<br>    五、我们如何处理未成年人的个人信息<br>    1、我们非常重视对未成年人个人信息的保护。若您是18周岁以下的未成年人，在使用我们的服务前，应事先取得您家长或法定监护人的书面同意。我们将根据国家相关法律法规的规定保护未成年人的个人信息。<br>    2、对于经父母或法定监护人同意而收集未成年人个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用或公开披露此信息。<br>    3、如果我们发现自己在未事先获得可证实的父母或法定监护人同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关数据。<br><br>    六、您的个人信息如何在全球范围转移<br>&nbsp; &nbsp; &nbsp; &nbsp; 原则上，我们在中华人民共和国境内收集和产生的个人信息，将存储在中华人民共和国境内。如果需要将您的个人信息转移到境外，我们将另行获得您的授权同意，在此情况下我们会依据本政策以使您的个人信息得到足够的保护。<br>    七、本政策如何更新<br>我们的隐私政策可能变更。<br>&nbsp; &nbsp; &nbsp; &nbsp; 未经您明确同意，我们不会削减您按照隐私政策所应享有的权利。我们会以通告的形式发布对本政策所做的任何变更。在该种情况下，若您继续使用我们的服务，即表示您同意接受修订后的隐私政策约束。<br>  八、如何联系我们<br>&nbsp; &nbsp; &nbsp; &nbsp; 如果您对本隐私政策有任何疑问、意见或建议，可以随时通过拨打客服电话、使用“大学掌”微信公众号人工客服各种方式与我们联系，我们会积极进行查证、处理并尽快答复。<br><p></p>',
      }).then(() => {
        this.readAgrement = true
      });
    },
    /* 支付方式弹出（弹出之前进行表单校验） */
    payShow() {
      // TODO 整个表单校验
      this.formList.forEach((e) => {
        this.blurField(e);
      });
      console.log('formList', this.formList)
      // TODO 一旦有校验文字 表单不可提交
      this.$nextTick(() => {
        if (this.defaultFormCheck() && this.formList.length && this.formList.every((item) => item.checkTxt == "")) {
          this.form.username = this.getIndex("name") ? this.formList[this.getIndex("name")].value : '';
          this.form.smsCode = this.getIndex("verifycode") || this.getIndex("verifycode") == 0 ? this.formList[this.getIndex("verifycode")].value : '';
          this.form.extend.stuno = this.getIndex("studentno") ? this.formList[this.getIndex("studentno")].value : '';
          this.form.extend.idcard = this.getIndex("idcard") ? this.formList[this.getIndex("idcard")].value : '';
          this.form.extend.room = this.getIndex("dormitory") ? this.formList[this.getIndex("dormitory")].value : '';
          this.form.extend.roomnum = this.getIndex("roomnum") ? this.formList[this.getIndex("roomnum")].value : '';
          this.form.extend.serpwd = this.getIndex("servicepwd") ? this.formList[this.getIndex("servicepwd")].value : '';
          this.form.extend.netpwd = this.getIndex("onlinepwd") ? this.formList[this.getIndex("onlinepwd")].value : '';
          this.form.extend.enable5g = this.getIndex("enable5g") ? this.formList[this.getIndex("enable5g")].value : ''
          this.form.extend.handleType = this.getIndex("handleType") ? this.formList[this.getIndex("handleType")].value : ''
          this.submit(this.form);
        } else {
          if (this.formList.length == 0) {
            this.$toast.fail("提交表单不能为空，请先设置表单！");
          }
        }
      });
    },
    /* 表单提交 */
    submit(form) {
      console.log('提交信息', form, this.formList);
      // 本地缓存openid不能等于字符串null
      if (this.form.extend.wxopenid == 'null') {
        this.form.extend.wxopenid = ''
      }
      // // 有验证码并且验证码通过
      // if (!this.vcodeCheck && this.getIndex("verifycode") && this.formList[this.getIndex("verifycode")].value) {
      //   return this.$toast.fail("验证码不正确");
      // }
      // 阅读协议
      if (this.readAgrement == true) {
        // TODO 宽带订单需要获取宽带创建方式 开卡和营销直接调用接口
        if (this.vueType == 'kd') {
          this.kdCreateType()
        } else {
          this.submitRequest(form)
        }

      } else {
        this.$toast.fail("请认真阅读《大学掌用户服务协议及隐私政策》并勾选");
      }
    },
    /* 提交请求 */
    submitRequest (form) {
      let url = this.url + "insert";
      this.axios.post(url, {
        acti: this.$route.query.acti,
        ...form
      }).then((res) => {
        this.resultHandle(res);
      }).catch(() => {
      });
    },
    /* 获取宽带创建方式（仅仅只有宽带调用） */
    kdCreateType () {
      let url = this.url + "create-type";
      this.axios
      .get(url, {
        params: {
          campusCode: this.form.schcode, // 校区代码
          operatorCode: this.form.seloper, // 运营商
          phone: this.form.telephone, // 手机号
          studentNo: this.formList[this.getIndex("studentno")].value, // 学号
        },
      })
      .then((res) => {
        if (res.data.code == 0) {
          if (res.data.data || res.data.data == 0) {
            this.form.extend.certdocktype = res.data.data;
            this.submitRequest(this.form)
            // 提交订单
          } else {
           this.certdocktypeShow = true
          }
        } else {
          this.$toast.fail("订单正在支付...");
        }
      });
    },
    /* 弹窗取消 */
    certdocktypeCancel () {
      this.form.extend.certdocktype = 0;
      this.submitRequest(this.form)
    },
    /* 弹窗确认 */
    certdocktypeConfirm () {
      this.form.extend.certdocktype = 2;
      this.submitRequest(this.form)
    },
    /* 提交结果接口返回处理 */
    resultHandle(res) {
      if (res.data.code === 0) { // 直接跳转结果页
        this.$toast.success("提交成功");
        this.$router.push({
          name: this.resultRouterName,
          query: {
            enterType: commonApi.isWeiXin() ? 1 : 0,
            orderCode: res.data.order.code,
          },
        });
      } else if (res.data.code === 3) { // 选择支付方式
        if (res.data.order) {
          this.ordecode = res.data.order.code;
        }
        this.showPayMethod = true;
      } else {
        this.$toast.fail(res.data.msg);
      }
    },
    /* 定时获取订单支付状态 */
    getOrderPayState() {
      let url = this.url + "getOrderState";
      this.axios
          .get(url, {
            params: {
              ordecode: this.ordecode,
            },
          })
          .then((res) => {
            if (res.data.data.state && res.data.data.state > 1) {
              clearInterval(this.timer);
              // enterType  入口类型，通过微信提交1、一般页面提交0
              // orderCode  订单编号
              this.$router.push({
                name: this.resultRouterName,
                query: {
                  enterType: commonApi.isWeiXin() ? 1 : 0,
                  orderCode: res.data.data.code,
                },
              });
            } else {
              this.$toast.fail("订单正在支付...");
            }
          });
    },
    /**
     * 支付  start
     * **/
    /* 支付方式选择 */
    payPrice(val) {
      this.form.paytype = val;
      if (val == 2) {
        // 支付宝
        let url = `${window.serverConfig.baseUrl}pay/alipay?ordecode=${this.ordecode}`;
        this.iframeUrl = url;
        this.timer = setInterval(() => {
          this.getOrderPayState();
        }, 3000);
        // window.location.href = url;
      }
      if (val == 1) {
        // 微信
        if (commonApi.isWeiXin()) {
          // 如果是微信浏览器打开鉴权拉起支付
          this.wechatSDK();
        } else {
          // 调用H5微信支付
          this.weChatH5Pay();
        }
      }
    },
    /* 微信端sdk鉴权 */
    wechatSDK() {
      let param = {
        openId: this.form.extend.wxopenid, // 当前用户微信的openid
        ordecode: this.ordecode, // 应付金额
      };
      this.axios
          .get("/pay/jsapipay", {
            params: {
              ...param,
            },
          })
          .then((response) => {
            if (response.data.code === 0) {
              // eslint-disable-next-line
              wx.config({
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: response.data.data.appId, // 必填，公众号的唯一标识
                timestamp: response.data.data.timeStamp, // 必填，生成签名的时间戳
                nonceStr: response.data.data.nonceStr, // 必填，生成签名的随机串
                signature: response.data.data.sign, // 必填，签名
                jsApiList: ["chooseWXPay"], // 必填，需要使用的JS接口列表
              });
              let that = this;
              // eslint-disable-next-line
              wx.ready(() => {
                // alert('鉴权成功')
                that.weChatPay(response);
              });
            } else {
              this.$toast("获取微信配制失败");
            }
          });
    },
    /* 拉起微信支付 */
    weChatPay(response) {
      let params = {
        timestamp: response.data.data.timeStamp, // 支付签名时间戳，注意微信js sdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
        nonceStr: response.data.data.nonceStr, // 支付签名随机串，不长于 32 位
        package: "prepay_id=" + response.data.data.prepay_id, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
        signType: "MD5", // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
        paySign: response.data.data.sign, // 支付签名
      };
      let that = this;
      // eslint-disable-next-line
      wx.chooseWXPay({
        ...params,
        success: function () {
          that.$router.push({
            name: that.resultRouterName,
            query: {
              enterType: commonApi.isWeiXin() ? 1 : 0,
              orderCode: that.ordecode,
            },
          });
        },
        fail: function () {
          that.$toast("支付失败。");
        },
        cancel: function () {
          that.$toast("取消支付，如需支付请继续。");
        },
      });
    },
    /* 微信H5支付 */
    weChatH5Pay() {
      let param = {
        openId: this.form.extend.wxopenid, // 当前用户微信的openid
        ordecode: this.ordecode, // 应付金额
      };
      this.axios
          .get("/pay/h5pay", {
            params: {
              ...param,
            },
          })
          .then((res) => {
            if (res.data.code === 0) {
              // this.iframeUrl = `${res.data.data}`;
              this.timer = setInterval(() => {
                this.getOrderPayState();
              }, 1000);
              window.location.href = res.data.data;
            } else {
              this.$toast("获取微信配制失败");
            }
          });
    },
    /* 获取指定表单id中数据的下标 */
    getIndex(id) {
      let index = (this.formList || []).findIndex((item) => item.id == id);
      return index < 0 ? null : index;
    },
    /* 跳转5G页面 */
    jump5g () {
      this.show5g = true
      // this.$router.push({name: 'enable5g'})
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>
<style scoped lang="scss">
.rich-text-container {
  font-size: 0.28rem;
}
.task{ position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.2); z-index: 999;
  .imgCode{ width: 6.3rem; background: #fff; top: 30%; margin: 0 auto; position: relative; border-radius: 15px; padding: .3rem;
    .close{ position: absolute; top: .3rem; right: .3rem; width: .24rem; height: .24rem;}
    h1{ font-size: .32rem; display: flex; align-items: center; color: #5f5f7e;
      img{ width: .28rem; height: .33rem; margin-right: 5px;}
    }

    .imgCodeCon{ display: flex; margin: .4rem 0;
      .txt{ background: #f7f7f7; margin-right: .15rem; border-radius: 5px;}
      img{ width: 88px; height: 44px;}
    }
    .des{ color: #aaa; text-align: center; padding-top: 10px;}
  }
}
</style>
<style>
#home .content .van-cell {
  background: #f7f7f7;
  border-radius: 5px;
  margin-bottom: 12px;
}

#home .van-field__label {
  width: auto;
}

#home .van-radio__label {
  margin-left: 2px;
}

#home .van-field__label {
  margin-right: 0px;
}

#home .van-submit-bar__bar {
  padding-right: 0;
}

#home .van-submit-bar__price {
  color: #fc5e3a;
}

.van-cell--required::before {
  top: 12px;
}

.van-field__control {
  padding-left: 5px !important;
}

.van-dialog__message--has-title {
  text-align: left
}
.toBar{ position: relative !important; bottom: 0 !important; left: 0 !important;}
.height1{ height: .3rem !important;}
</style>
